module.exports = __webpack_public_path__ + "img/ppj.2cbec730.png";